import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Action, Dispatch } from "redux";
import { Customer } from "../../domain/model/customer";
import { JobCareer } from "../../domain/model/job_career";
import { PastCaseProject } from "../../domain/model/past_case_project";
import { createCustomerTopPageActionCreator } from "../action/customer_top_page_action";
import CustomerTopPageComponent from "../component/customer/top_page/customer_top_page";
import {
  createCustomerTopPageDispatcher,
  ICustomerTopPageDispatcher,
} from "../dispatcher/customer_top_page_dispatcher";
import { AppState } from "../store/app_state";
import { CustomerTopPageState } from "../store/customer_top_page_state";

interface IProps extends RouteComponentProps<{}> {
  state: CustomerTopPageState;
  dispatcher: ICustomerTopPageDispatcher;
}

interface IState {
  isInit: boolean;
}

export class CustomerTopPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    this.props.dispatcher.getMeCustomer();
  }

  public render(): JSX.Element {
    const { state } = this.props;

    const { isInit } = this.state;

    const customer: Customer | null = state.customer;
    const jobCareers: JobCareer[] = state.jobCareers;
    const pastCaseProjects: PastCaseProject[] = state.pastCaseProjects;

    const { isLoading } = state;

    return (
      <CustomerTopPageComponent
        isInit={isInit}
        isLoading={isLoading}
        customer={customer}
        jobCareers={jobCareers}
        pastCaseProjects={pastCaseProjects}
        handleStartStandard={this.handleStartStandard}
      />
    );
  }

  private handleStartStandard = () => {};
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.customerTopPageReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createCustomerTopPageDispatcher(
      dispatch,
      createCustomerTopPageActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTopPage);



// WEBPACK FOOTER //
// ./src/presentation/container/customer_top_page_container.tsx